import { TranslationObject } from '../i18n/translation';

const namespace = 'dashboard.student';
const translations: TranslationObject = {
  title: { id: `${namespace}.title`, nb: 'Dashbord', en: 'Dashboard' },
  welcome: {
    id: `${namespace}.welcomeMessage`,
    nb: 'Hei {name} og velkommen til  Arbeidslivsportalen',
    en: 'Hi {name} and welcome to Arbeidslivsportalen',
  },
  desc: {
    id: `${namespace}.desc`,
    nb: 'Her vil du finne alle praksisaktivitetene dine og statusen på dem.',
    en: 'Here you will find your work placements and their status',
  },
  addressinfo: {
    id: `${namespace}.addressinfo`,
    nb: 'Husk at studiestedet kan bruke din semesterregistrerte adresse for å planlegge og beregne prakis. Derfor er det ekstra viktig at du ser over at kontaktinformasjonen og semesteradressen din stemmer.',
    en: 'Your place of study might use your address to plan work practice. It is therefore important that you confirm that your contact information and address is correct.',
  },

  name: { id: `${namespace}.name`, nb: 'Navn', en: 'Name' },
  studentnr: { id: `${namespace}.studentnr`, nb: 'Studentnr', en: 'Studentnr' },
  gender: { id: `${namespace}.gender`, nb: 'Kjønn', en: 'Gender' },
  age: { id: `${namespace}.age`, nb: 'Alder', en: 'Age' },
  contact: {
    id: `${namespace}.contact`,
    nb: 'Kontaktinformasjon',
    en: 'Contact information',
  },
  street: {
    id: `${namespace}.street`,
    nb: 'Gateadresse',
    en: 'Street name and house number',
  },
  postcode: { id: `${namespace}.postcode`, nb: 'Postnummer', en: 'Post code' },
  posttown: { id: `${namespace}.posttown`, nb: 'Poststed', en: 'Town' },
  email: { id: `${namespace}.email`, nb: 'Epost', en: 'Email' },
  telephone: {
    id: `${namespace}.telephone`,
    nb: 'Telefonnummer',
    en: 'Phone number',
  },
  update: {
    id: `${namespace}.update`,
    nb: 'Hvis adressen din ikke stemmer, er det viktig at du oppdaterer den i Studentweb.',
    en: 'If your address is incorrect please update it in Studentweb.',
  },
  understood: {
    id: `${namespace}.understood`,
    nb: 'Jeg forstår',
    en: 'I understand',
  },
};

export default translations;
